export default {
      id: "ic_arrow_down_white_v2-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_down_white_v2-usage",
      toString: function () {
        return this.url;
      }
    }